import React, { FunctionComponent, useEffect } from "react";

import {
    Wrapper,
    Header,
    StyledModal,
    HeaderText,
    CloseButton,
    Content,
    Backdrop,
    Logo,
    ContentTitle,
    Solutions,
    Solution,
    SolutionText,
} from "./modal.style";
import { StyledAnchorLink } from "../buttons/default.style";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

export interface ModalProps {
    headerText: string;
    logo: string;
    solutions: string[];
}

export const Case: FunctionComponent<ModalProps> = ({ headerText, logo, solutions }) => {
    const navigate = useNavigate();
    const hide = () => {
        navigate(-1);
    };
    const { formatMessage } = useIntl();
    return (
        <React.Fragment>
            <Backdrop />
            <Wrapper>
                <StyledModal>
                    <Header>
                        <Logo src={logo}></Logo>
                        <HeaderText>
                            {formatMessage({
                                id: headerText,
                            })}
                        </HeaderText>
                        <CloseButton onClick={hide}>
                            <img src={`${process.env.PUBLIC_URL}/index/close_cross.svg`} />
                        </CloseButton>
                    </Header>
                    <Content>
                        <ContentTitle>
                            <FormattedMessage id='index_page.our_cases_section.case_study.solutions' />
                        </ContentTitle>
                        <Solutions>
                            {solutions.map((solution, index) => (
                                <Solution key={index}>
                                    <SolutionText>
                                        {formatMessage({
                                            id: solution,
                                        })}
                                    </SolutionText>
                                </Solution>
                            ))}
                        </Solutions>
                        <StyledAnchorLink to='/#demo'>
                            <FormattedMessage id='index_page.our_cases_section.case_study.conversion_button' />
                        </StyledAnchorLink>
                    </Content>
                </StyledModal>
            </Wrapper>
        </React.Fragment>
    );
};
